import { SendBezPripomienokApi } from 'pripomienky-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import apiConfiguration from './configuration/apiConfiguration';
import { ClientResponse } from '../model/ClientResponse';
import Uuid from '../model/Uuid';
import { pripomienkyPrefixPath } from './configuration/apiConfigurationConstants';

const client = new SendBezPripomienokApi(apiConfiguration(pripomienkyPrefixPath));

export const sendBezPripomienok = async (
  type: string,
  year: number,
  index: number,
  options?: AxiosRequestConfig,
):
  Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.sendBezPripomienok(
    type,
    year,
    index,
    options,
  );
  return {
    responseCode: status,
  };
};

export const sendBezPripomienokAdmin = async (
  type: string,
  year: number,
  index: number,
  datumOdoslania: string,
  orgId: Uuid,
  options?: AxiosRequestConfig,
):
  Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.sendBezPripomienokAdmin(
    type,
    year,
    index,
    {
      datumOdoslania,
      orgId,
    },
    options,
  );
  return {
    responseCode: status,
  };
};
